<script lang="ts">
  import { cubicInOut } from "svelte/easing";
  import { crossfade } from "svelte/transition";
  import { cn } from "$lib/utils.js";
  import { Button } from "$lib/components/ui/button";
  import {location} from 'svelte-spa-router'
  import type { NavItem } from "./NavItems";

  let className: string | undefined | null = undefined;
  export let items: NavItem[];
  export let isActiveLocation: (currentLocation: string, item: NavItem) => boolean;
  
  const [send, receive] = crossfade({
    duration: 250,
    easing: cubicInOut,
  });

</script>

<div
  class="flex-grow max-w-xl flex-row justify-between text-center hidden md:flex mx-5"
>

  {#each items as item}
    <!-- $page.url.pathname === item.href -->
    <!-- {@const isActive = false} -->
    <Button href={item.href} size="sm" variant="tab" class={cn(isActiveLocation($location, item) ? "border-secondary-foreground text-foreground" : "", "gap-2 rounded-none")}>
      <svelte:component this={item.icon} size="16" />
      <div class="hidden lg:block">
        {item.title}
      </div>
    </Button>
  {/each}
</div>
